$(document).ready(function(){

    /* SWITCH PRICE MONTH / YEAR */
    $('.js-switch-item').on('click', function(){
        $('.js-switch-item').removeClass('active');
        $(this).addClass('active');
        let subscription = $(this).data('item'); 
        $('.js-offer-list').removeClass('active');
        $('.js-offer-list[data-item='+subscription+']').addClass('active');
    });


    /* ACCORDION */
    $('.js-accordion-title').on('click', function(){
        if( $(this).hasClass('active') ){
            $(this).removeClass('active');
            $(this).closest('.js-accordion-item').find('.js-accordion-text').slideUp(200);
        }
        else{
            $('.js-accordion-title').removeClass('active');
            $('.js-accordion-text').slideUp(200);
            $(this).addClass('active');
            $(this).closest('.js-accordion-item').find('.js-accordion-text').slideDown(200);
        }
    });


    /* OVERLAY */
    function showOverlay(){
        $('.overlay').fadeIn(200);
    }
    function hideOverlay() {
        $('.overlay').fadeOut(200);
    }

    $('.overlay').on('click', function(){
        hideOverlay();
        $('.js-menu-mobile').removeClass('active');
        $('.js-account-mobile').removeClass('active');
    });


    /* MENU MOBILE */
    $('.js-open-menu-mobile').on('click', function(){
        if( $(window).innerWidth() < 1024 ){
            showOverlay();
            $('.js-menu-mobile').addClass('active');
        }
    });

    $('.js-close-menu-mobile').on('click', function () {
        hideOverlay();
        $('.js-menu-mobile').removeClass('active');
    });


    /* ACCOUNT MOBILE */
    $('.js-open-account-mobile').on('click', function () {
        if ($(window).innerWidth() < 1024) {
            showOverlay();
            $('.js-account-mobile').addClass('active');
        }
    });

    $('.js-close-account-mobile').on('click', function () {
        hideOverlay();
        $('.js-account-mobile').removeClass('active');
    });


    /* CART MOBILE */
    $('.js-cart-open').on('click', function(){
        $('.js-cart').addClass('active');
        $('.js-cart-mobile-top').hide(0);
        $('.js-cart-close').addClass('active');
    });

    $('.js-cart-close').on('click', function () {
        $('.js-cart').removeClass('active');
        $('.js-cart-mobile-top').show(0);
        $('.js-cart-close').removeClass('active');
    });



    /* FORM VERIFICATION */

    /* PASSWORD CHECK HELPERS */
    let passwordLengthOk = 0;
    let passwordUppercaseOk = 0;
    let passwordLowercaseOk = 0;
    let passwordStrength = 0;
    $('.js-password-input').on("keyup", function () {
        let password = $(this).val();

        let passwordLength = password.length;
        if (passwordLength >= 8) {
            $('.js-password-helper-number').addClass('active');
            passwordLengthOk = 1;
        }
        else {
            $('.js-password-helper-number').removeClass('active');
            passwordLengthOk = 0;
        }

        let uppercaseRegex = /([A-Z])/g;
        if (password.match(uppercaseRegex)) {
            $('.js-password-helper-caps').addClass('active');
            passwordUppercaseOk = 1;
        }
        else {
            $('.js-password-helper-caps').removeClass('active');
            passwordUppercaseOk = 0;
        }

        let lowercaseRegex = /([a-z])/g;
        if (password.match(lowercaseRegex)) {
            $('.js-password-helper-low').addClass('active');
            passwordLowercaseOk = 1;
        }
        else {
            $('.js-password-helper-low').removeClass('active');
            passwordLowercaseOk = 0;
        }
    });

    function checkPasswordStrength(){
        passwordStrength = passwordLengthOk + passwordUppercaseOk + passwordLowercaseOk;
        if (passwordStrength == 3){
            return true;
        }
        else{
            let msg = $('.js-password-input').closest('.line-form').data('error-msg-format');
            $('.js-password-input').closest('.line-form').find('.js-error-msg').html(msg);
            $('.js-password-input').closest('.line-form').addClass('has-error');
        }
    }

    function checkInputRequired(formId) {
        $('#' + formId + ' input').each(function () {
            if ($(this).prop('required')) {
                if ($(this).val() == '' || !$(this).val()) {
                    $(this).closest('.line-form').addClass('has-error');
                    let msg = $(this).closest('.line-form').data('error-msg-empty');
                    $(this).closest('.line-form').find('.js-error-msg').html(msg);
                }
                else {
                    $(this).closest('.line-form').removeClass('has-error');
                }
            }
        });
    }

    function confirmEmail(formId) {
        let email1 = $('#' + formId + ' .js-set-email').val();
        let email2 = $('#' + formId + ' .js-confirm-email').val();
        if (email1 != email2) {
            return false;
        } else {
            return true;
        }
    }

    function confirmPassword(formId) {
        if ($('.js-confirm-password').length ){
            let password1 = $('#' + formId + ' .js-set-password').val();
            let password2 = $('#' + formId + ' .js-confirm-password').val();
            if (password1 != password2) {
                $('.js-confirm-password').closest('.line-form').addClass('has-error');
                let msg = $('.js-confirm-password').closest('.line-form').data('error-msg-different');
                $('.js-confirm-password').closest('.line-form').find('.js-error-msg').html(msg);
            } else {
                return true;
            }
        }
        
    }

    function checkInputEmail(formId) {
        $('#' + formId + ' input[type=email]').each(function () {
            if ($(this).val()) {
                if ($(this).hasClass('js-confirm-email') && !confirmEmail(formId)) {
                    $(this).closest('.line-form').addClass('has-error');
                    let msg = $(this).closest('.line-form').data('error-msg-different');
                    console.log(msg);
                    $(this).closest('.line-form').find('.js-error-msg').html(msg);
                }
                else if (!Boolean($(this).val().match(/^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i))) {
                    $(this).closest('.line-form').addClass('has-error');
                    let msg = $(this).closest('.line-form').data('error-msg-format');
                    $(this).closest('.line-form').find('.js-error-msg').html(msg);
                }
            }
            else {
                if ($(this).prop('required')) {
                    $(this).closest('.line-form').addClass('has-error');
                    let msg = $(this).closest('.line-form').data('error-msg-empty');
                    $(this).closest('.line-form').find('.js-error-msg').html(msg);
                }
                else {
                    $(this).closest('.line-form').removeClass('has-error');
                }
            }
        });
    }

    $('input[type=email]').on("cut copy paste", function (e) {
        e.preventDefault();
    });

    function checkInputCheckbox(formId) {
        $('#' + formId + ' input[type=checkbox]').each(function () {
            if ($(this).prop('required')) {
                if (!$(this).is(':checked')) {
                    let msg = $(this).closest('.line-form').data('error-msg-empty');
                    $(this).closest('.line-form').find('.js-error-msg').html(msg);
                    $(this).closest('.line-form').addClass('has-error');
                }
                else {
                    $(this).closest('.line-form').removeClass('has-error');
                }
            }
        });
    }

    function checkFormRequiredFields(formId) {
        checkInputRequired(formId);
        checkInputEmail(formId);
        checkInputCheckbox(formId);
        checkPasswordStrength(formId);
        confirmPassword(formId);
        
    }

    $('input').on('focus', (e) => {
        let $this = $(e.target);
        $this.closest('.line-form').removeClass('has-error');
    });
    $('input[type="checkbox"]').on('change', (e) => {
        let $this = $(e.target);
        if ($this.closest('.line-form').hasClass('has-error')) {
            $this.closest('.line-form').removeClass('has-error');
        }
    });

    $('.button-submit').on('click', function(e){
        e.preventDefault();
        let id = $(this).closest('form').attr('id')
        checkFormRequiredFields(id);
        if( !$('.has-error').length ){
            $(this).closest('form').submit();
        }
    });


    /* PASSWORD SHOW / HIDE */
    $('.js-password-button').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).closest('.input-field').find('.js-password-input').prop('type', 'password');
        }
        else {
            $(this).addClass('active');
            $(this).closest('.input-field').find('.js-password-input').prop('type', 'text');
        }
    });


    /* BILLING ADDRESS */
    $('.js-billing-address').change(function () {
        if ($(this).is(":checked")) {
            $('.js-form-billing-address').show(0);
            $('.js-billing-required').prop('required', true);
        }
        else{
            $('.js-form-billing-address').hide(0);
            $('.js-billing-required').prop('required', false);
            $('.js-form-billing-address .has-error').removeClass('has-error');
        }
    });

    /* PAYMENT FREQUENCY */
    $('.js-input-monthly').change(function () {
        if ($(this).is(":checked")) {
            $('.js-frequency-monthly').show(0);
            $('.js-frequency-annual').hide(0);
        }
    });

    $('.js-input-annual').change(function () {
        if ($(this).is(":checked")) {
            $('.js-frequency-monthly').hide(0);
            $('.js-frequency-annual').show(0);
        }
    });

    /* PAYMENT METHOD */
    $('.js-payment-sepa').change(function () {
        if ($(this).is(":checked")) {
            $('.js-form-sepa').show(0);
            $('.js-form-card').hide(0);
            $('.js-form-card .js-billing-required').prop('required', false);
            $('.js-form-sepa .js-billing-required').prop('required', true);
            $('.js-form-sepa  .has-error').removeClass('has-error');
        }
    });
    $('.js-payment-card').change(function () {
        if ($(this).is(":checked")) {
            $('.js-form-sepa').hide(0);
            $('.js-form-card').show(0);
            $('.js-form-sepa .js-billing-required').prop('required', false);
            $('.js-form-card .js-billing-required').prop('required', true);
            $('.js-form-card  .has-error').removeClass('has-error');
        }
    });
    $('.js-payment-paypal').change(function () {
        if ($(this).is(":checked")) {
            $('.js-form-card').hide(0);
            $('.js-form-card .js-billing-required').prop('required', false);
            $('.js-form-sep').hide(0);
            $('.js-form-sep .js-billing-required').prop('required', false);
        }
    });
    

    /* AVANTAGES */
    $('.js-show-advantages').on('click', function(){
        if( $(this).hasClass('active') ){
            $(this).removeClass('active')
            $(this).parent().parent().find('.js-advantages').slideUp(200);
        }
        else{
            $(this).addClass('active')
            $(this).parent().parent().find('.js-advantages').slideDown(200);
        }
    });


    $('.js-offers-mobile-button').on('click', function(){
        $('.js-offers-mobile-button').removeClass('active');
        $(this).addClass('active');
        let period = $('.js-offer-list.active').data('item');
        let index = $(this).data('index');

        let elementToScroll = '';
        if (period == 'mois'){
            elementToScroll = $('.js-offers-item-month-' + index);
        }
        else{
            elementToScroll = $('.js-offers-item-year-' + index);
        }
        
        $("html").animate(
            {
                scrollTop: (elementToScroll.offset().top - 270)
                
            },
            800 //speed
        );

    });


    $('.js-offers-mobile-button-v2').on('click', function () {
        $('.js-offers-mobile-button-v2').removeClass('active');
        $(this).addClass('active');
        let index = $(this).data('index');
        $('.js-offers-item').removeClass('active');
        $('.js-offers-item-' + index).addClass('active');
    });


    /* FAQ */
    $('.js-faq-index-title-with-children').on('click', function () {
        $('.js-faq-index-subtitle').removeClass('show');
        $('.js-faq-index-item').removeClass('active');
        $(this).closest('.js-faq-index-item').addClass('active');
        $(this).closest('.js-faq-index-item').find('.js-faq-index-subtitle').addClass('show');
    });

    $('.js-faq-index-title').on('click', function () {
        $('.js-faq-index-subtitle').removeClass('show');
        $('.js-faq-index-item').removeClass('active');
        $(this).closest('.js-faq-index-item').addClass('active');
    });

    $('[data-open-faq]').on('click', function () {
        $('.js-faq-index-item').removeClass('active');
        $('.js-faq-index-subtitle').removeClass('active');
        $(this).closest('.js-faq-index-item').addClass('active');
        $(this).addClass('active');
        
        $('.js-faq').removeClass('active');
        $('.js-' + $(this).data('open-faq')).addClass('active');
        if( $(window).width() < 1024){
            $('.js-faq-index-selector-mobile-selected').html($(this).html());
            $('.js-faq-index').slideUp(200);
        }


    });
    
    $('.js-faq-index-selector-mobile').on('click', function(){
        $('.js-faq-index').slideDown(200);
    });


    /* CODE PROMO */
    $('.js-code-promo-button').on('click', function(){
        if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            $('.js-code-promo-form').slideUp(200);
        }
        else {
            $(this).addClass('active')
            $('.js-code-promo-form').slideDown(200);
        }
    });

    function checkInputCodePromo(codeValue) {
        // define here how to verify if the code is valid
        // if code ok return true , else return false
        return false;
    }

    function showHideErrorCodePromo() {
        let codeValue = $('.js-code-promo-value').val();
        if ( !checkInputCodePromo(codeValue)) {
            let msg = $('.js-code-promo').data('error-code');
            $('.js-code-promo').find('.js-error-msg').html(msg);
            $('.js-code-promo').addClass('has-error');
        }
        else {
            $('.js-code-promo').removeClass('has-error');
        }
    }

    $('.js-code-promo-valid').on('click', function(){
        showHideErrorCodePromo()
    });
    
});